
const error_txt_rus = {
    '1000': 'Неправильный Email',
    '1001': 'Неправильный пароль',
    '1002': 'Неправильный адрес кошелька',
    '1003': 'Неверно указана сумма',
    '1004': 'Неверный Email или пароль',
    '1005': 'Сумма меньше минимально допустимой (10 USD)',
    '1006': 'Ошибка внешнего сервера, попробуйте посвторить транзакцию позже',
    '1007': 'Ошибка внешнего сервера, попробуйте посвторить транзакцию позже',
    '1008': 'Превышен лимит комиссии за обмен',
    '1009': 'Сумма превышает максимальное значение',
    '1010': 'Внутренняя ошибка сервера, попробуйте посвторить транзакцию позже',
    '1011': 'Ошибка соединения с провайдером, попробуйте повторить транзакцию позже',
    '1012': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1013': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1014': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1015': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1016': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1017': 'Ошибка соединения с провайдером, попробуйте посвторить транзакцию позже',
    '1018': 'Превышение лимита комиссионных в сети Эфир',
    '1019': 'Ошибка при проверке вашего аккаунта, пожалуйста попробуйте повторить транзакцию позже',
    '1020': 'Данный кошелек уже зарегистрирован другим пользователем',
    '1021': 'Внутренняя ошибка сервера, попробуйте посвторить транзакцию позже',
    '1022': 'Внутренняя ошибка сервера, попробуйте посвторить транзакцию позже',
    '1023': 'Внутренняя ошибка сервера, попробуйте посвторить транзакцию позже',
    '1024': 'Сумма USDT меньше минимально допустимой',
    '1025': 'Недостаточно FA.Unit на вашем кошельке',
};

const error_txt_eng = {
    '1000': 'Incorrect Email',
    '1001': 'Incorrect password',
    '1002': 'Incorrect wallet address',
    '1003': 'The amount is incorrect',
    '1004': 'Incorrect Email or password',
    '1005': 'The amount is less than 10 USDT',
    '1006': 'External server error, retry the transaction later',
    '1007': 'External server error, retry the transaction later',
    '1008': 'Commission limit is exceeded',
    '1009': 'The amount is more than maximum amount',
    '1010': 'Internal server error, retry the transaction later',
    '1011': 'Connection error with provider, retry the transaction later',
    '1012': 'Connection error with provider, retry the transaction later',
    '1013': 'Connection error with provider, retry the transaction later',
    '1014': 'Connection error with provider, retry the transaction later',
    '1015': 'Connection error with provider, retry the transaction later',
    '1016': 'Connection error with provider, retry the transaction later',
    '1017': 'Connection error with provider, retry the transaction later',
    '1018': 'Exceeding the Ethereum commission limit',
    '1019': 'Verification error in your account, retry the transaction later',
    '1020': 'This wallet has been already registered by another user',
    '1021': 'Internal server error, retry the transaction later',
    '1022': 'Internal server error, retry the transaction later',
    '1023': 'Internal server error, retry the transaction later',
    '1024': 'USDT amount is less than the minimum allowed',
    '1025': 'Not enough FA.Unit in your wallet',
};

let language = 'eng';
export function SetErrorLanguage(lang) {
    language = lang;
}

export function GetErrorText(code) {
    code = code.toString();
    if (language === 'rus') {
        return error_txt_rus[code];
    }
    return error_txt_eng[code];
}
